import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { TeamOutlined, UserAddOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import ClientsList from './List/List';
import ClientsInvite from './Invite/Invite';
import ClientsPermissions from './Permissions/Permissions';

const { Title } = Typography;

const Clients = () => {
  const [activeTab, setActiveTab] = useState('list');

  const items = [
    {
      key: 'list',
      label: (
        <span>
          <TeamOutlined /> Client List
        </span>
      ),
      children: <ClientsList />
    },
    {
      key: 'invite',
      label: (
        <span>
          <UserAddOutlined /> Invite New Client
        </span>
      ),
      children: <ClientsInvite />
    },
    {
      key: 'permissions',
      label: (
        <span>
          <SafetyCertificateOutlined /> Client Permissions
        </span>
      ),
      children: <ClientsPermissions />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Clients Management</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Clients;
